import { render, staticRenderFns } from "./Asilo.vue?vue&type=template&id=94c82844&scoped=true&"
import script from "./Asilo.vue?vue&type=script&lang=js&"
export * from "./Asilo.vue?vue&type=script&lang=js&"
import style0 from "./Asilo.vue?vue&type=style&index=0&id=94c82844&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c82844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
